<template>
  <div class="floating">
    <h2>Update your info</h2>
    <template v-if="formSuccess">
      <div role="alert">
        <p> You have successfully updated your profile info! </p>
      </div>
    </template> <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="first_name">First name</label> <input
          id="first_name"
          v-model="formFields.first_name"
          type="text"
          required
        > <div
          v-if="formErrors.first_name !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.first_name[0] }}
        </div>
      </div> <div class="form-group">
        <label for="last_name">Last name</label> <input
          id="last_name"
          v-model="formFields.last_name"
          type="text"
          required
        > <div
          v-if="formErrors.last_name !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.last_name[0] }}
        </div>
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          v-model="formFields.email"
          type="text"
          required
        >
        <div
          v-if="formErrors.email !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.email[0] }}
        </div>
      </div>
      <div class="form-group">
        <label for="phone">Phone</label>
        <input
          id="phone"
          v-model="formFields.phone"
          type="text"
          placeholder="Enter your phone number to get chat and notification messages"
        >
        <div
          v-if="formErrors.phone !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.phone[0] }}
        </div>
      </div>
      <div class="form-group">
        <label for="phone">Notification Preference</label>
        <select
          id="notification-preference"
          v-model="formFields.notification_preference"
        >
          <option
            v-if="formFields.phone"
            value="email+sms"
          >
            Email and Text Message
          </option>
          <option value="email">
            Email
          </option>
          <option
            v-if="formFields.phone"
            value="sms"
          >
            Text Message
          </option>
          <option value="web">
            Website Only
          </option>
        </select>
        <div
          v-if="formErrors.notification_preference !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.notification_preference[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="zip_code">Zip code</label>
        <input
          id="zip_code"
          v-model="formFields.zip_code"
          type="text"
          required
        >
        <p class="small">
          *The zip code will be used to filter your feed.
        </p>
        <div
          v-if="formErrors.zip_code !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.zip_code[0] }}
        </div>
      </div>

      <div class="form-group">
        <label>Distance</label>
        <select
          v-model="formFields.distance"
          required
        >
          <option value="25">
            Within 25 miles
          </option>
          <option value="50">
            Within 50 miles
          </option>
          <option value="150">
            Within 150 miles
          </option>
          <option value="250">
            Within 250 miles
          </option>
          <option value="500">
            Within 500 miles
          </option>
          <option value="12329">
            Any Distance
          </option>
        </select>
        <div
          v-if="formErrors.distance !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.distance[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="bio">Bio</label>
        <p class="small">
          Insert info if you are a dealer. If not, enter in what guns you are interested in
          and why you joined Gun Group.
        </p>
        <textarea
          id="bio"
          v-model="formFields.bio"
          rows="10"
          required
        />
        <div
          v-if="formErrors.bio !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.bio[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="avatar">Avatar</label>
        <div v-if="!changeAvatar">
          <avatar :user="userData" />
          <span
            v-if="avatar"
            class="avatar-opts"
          >
            <a
              href="#"
              @click.prevent="handleChangeAvatar"
            >Change</a> -
            <a
              href="#"
              @click.prevent="handleRemoveAvatar"
            >Remove</a>
          </span>
          <span
            v-else
            class="avatar-opts"
          >
            <a
              href="#"
              @click.prevent="handleChangeAvatar"
            >Upload</a>
          </span>
        </div>
        <div v-else>
          <image-uploader v-model="avatar" />
          <a
            v-if="avatar !== ''"
            href="#"
            @click.prevent="changeAvatar = false"
          >Cancel</a>
        </div>

        <div
          v-if="formErrors.avatar !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.avatar[0] }}
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Updating
        </template>
        <template v-else>
          Update Personal Info
        </template>
      </button>
    </form>
  </div>
</template>

<script>
import ImageUploader from '@virgodev/vue-image-crop/image_uploader.vue';
import { thumbnail } from '@virgodev/vue-image-crop/utils';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'UpdateProfile',
  components: {
    ImageUploader,
    Avatar,
  },
  data() {
    return {
      changeAvatar: false,
      avatar: this.$store.state.userData.avatar_url,
      formSubmitting: false,
      formErrors: {},
      formSuccess: false,
      formFields: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        notification_preference: '',
        zip_code: '',
        distance: '12329',
        bio: '',
        avatar: null,
      },
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.formFields = {
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        email: this.userData.email,
        phone: this.userData.phone,
        notification_preference: this.userData.notification_preference,
        zip_code: this.userData.zip_code,
        distance: this.userData.distance,
        bio: this.userData.bio,
      };
    },
    handleChangeAvatar() {
      this.avatar = null;
      this.changeAvatar = true;
    },
    handleRemoveAvatar() {
      this.avatar = '';
      this.changeAvatar = true;
    },
    async submitForm() {
      try {
        await this.submitForm2();
      } catch (ex) {
        // console.log('ex', ex);
      }
    },
    async submitForm2() {
      this.formErrors = {};
      this.formSubmitting = true;

      if (!this.changeAvatar) {
        delete this.formFields.avatar;
      } else if (this.avatar) {
        // new avatar
        try {
          this.formFields.avatar = await thumbnail(this.avatar, 512);
        } catch (ex) {
          delete this.formFields.avatar;
        }
      } else if (this.avatar === '') {
        // send blank avatar to delete current image
        this.formFields.avatar = '';
      }

      this.formFields.phone = this.formFields.phone || '';

      const responseData = await this.api({
        url: `users/${this.userData.id}/`,
        method: 'PUT',
        json: this.formFields,
      });

      if (responseData.status === 200) {
        this.changeAvatar = false;
        this.formSuccess = true;
        this.$store.commit('userData', responseData.body);
        this.$router.push(`/profile/${this.userData.id}`);
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_erros: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }

      this.formSubmitting = false;
    },
  },
};
</script>

<style scoped>
  .avatar-opts {
    margin-left: 10px;
    display: inline-block;
  }
</style>
